/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/6
 */
import './index.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getHot, getHome, getHomeByCid, getCategory, getProduct, getPageInfo } from '../../actions/home';
import Header from './header/index';
import SelectList from './selectList/index';
import ProductList from './productList/index';
import HotList from './hotList/index';
import QA from './qa/index';
import history from '../../routes/history';
import storage from '../../utils/sessionStorage';

class Home extends Component {
  constructor (props) {
    super(props);
    storage.clearItem('stepData');
    this.initRequest(this.props.location);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.location.state) return;

    let { cid, bid, current } = this.getInitState(nextProps.location);
    const { getCategory, getHomeByCid, getProduct, category, brand } = this.props;
    const currentState = this.getInitState(this.props.location);
    const currCid = currentState.cid || 1;
    const currBid = currentState.bid;
    const currPage = currentState.current;
    const isChange = (cid !== currCid || bid !== currBid || current !== currPage);

    if (!isChange) return;
    if (cid !== currCid) {
      getCategory(parseInt(cid, 10));
      getHomeByCid(parseInt(cid, 10), null, current);
    }
    if (bid !== currBid && !!bid) {
      getProduct(parseInt(cid, 10), parseInt(bid, 10), current);
    }
    if (current !== currPage && !!current) {
      cid = cid || category.current;
      bid = bid || brand.current;
      history.push(`/?cid=${cid}&bid=${bid}&current=${current}`);
      getProduct(parseInt(cid, 10), parseInt(bid, 10), current);
    }
  }

  /**
   * init homepage request
   */
  initRequest = (location) => {
    const { cid, bid, current, isPreview } = this.getInitState(location);
    const {
      brand,
      category,
      getHome,
      getHot,
      getCategory,
      getHomeByCid,
      getProduct,
      getPageInfo } = this.props;

    if (!cid & !bid) {
      history.push('/');
      getHome();
    } else if ((cid && !bid) || !brand.length) {
      getHomeByCid(parseInt(cid, 10), parseInt(bid, 10), current);
      if (category.list.length === 0) { getCategory(cid); }
    } else {
      getProduct(cid, bid, current);
    }

    getHot();
    getPageInfo(isPreview);
  }

  /**
   * get init query data
   */
  getInitState = (location) => {
    const state = location.state;
    const search = location.search.split('?')[1] || '';
    let res = {};

    if (!!state) { return state; }
    if (!search.length) {return {}}

    search.split('&').map((item, index) => {
      return res[item.split('=')[0]] = parseInt(item.split('=')[1], 10);
    });

    return res;
  }

  render (){
    return (
      <div className="mzcontainer">
        <Header />
        <SelectList category={ this.props.category } brand={ this.props.brand } />
        <ProductList product={ this.props.product } isHome={ true } />
        <HotList hot={ this.props.hot } />
        <QA />
      </div>
    )
  }
}

export default connect(
  state => ({
    brand: state.home.brand,
    category: state.home.category,
    product: state.home.product,
    hot: state.home.hot,
    pageInfo: state.home.pageInfo
  }),
  { getHot, getHome, getCategory, getHomeByCid, getProduct, getPageInfo }
)(Home)



// WEBPACK FOOTER //
// ./src/components/home/index.js